module.exports = __webpack_public_path__ + "img/a5.6637d191.jpg";